import React from 'react';

// Migration phase 2 (DS v1): the gradient orb decorations that used to live
// here have been removed — they bled into every page and competed with the
// tokenized surfaces in Card / DataTable / etc. Page background is now flat
// `bg-surface-bg` set on the authenticated layout root.
//
// Sidebar redesign: width tracks `--sidebar-w` set by AuthenticatedLayout
// (232 px full / 60 px rail). Falls back to the legacy 14rem (224 px) so
// pages mounted outside the layout (storybook-style harnesses) still
// render sensibly.
const DEFAULT_INNER_CLASS =
  'relative ml-0 mr-auto w-full lg:w-[calc(100vw-var(--sidebar-w,14rem))] max-w-[1600px] px-4 lg:px-6 py-4 lg:py-5';

export interface PageShellProps {
  children: React.ReactNode;
  className?: string;
}

const PageShell: React.FC<PageShellProps> = ({ children, className }) => {
  const innerClass = className && className.length > 0 ? className : DEFAULT_INNER_CLASS;

  return (
    <div className="relative min-h-screen overflow-x-hidden">
      <div className={innerClass}>{children}</div>
    </div>
  );
};

export default PageShell;
